import { gql } from '@apollo/client';

import { statementViewIngestionFields } from '../constants';

export const GET_TRQK_STATEMENT_VIEWS_FOR_USER_PARTIAL = gql`
    query getTrqkStatementViewsForUser($user_id: String!, $entity_id: String) {
        getTrqkStatementViewsForUser(user_id: $user_id, entity_id: $entity_id) {
            items {
                ${statementViewIngestionFields}
            }
        }
    }
`;
